
import { mapMutations, mapGetters } from 'vuex';
import searchFormMixin from '@/mixins/search-form-mixin';
export default {
    mixins: [searchFormMixin],
    data() {
        return {
            categoriesFound: [],
            productsFound: [],
            searchCategories: [],
            timeoutID: undefined
        };
    },
    computed: {
        ...mapGetters({
            getStateCatalog: 'getStateCatalog',
            getStateSearch: 'getStateSearch'
        })
    },

    watch: {
        getStateSearch(newVal) {
            if (newVal) {
                document.body.classList.add('popup-open');
            } else {
                document.body.classList.remove('popup-open');
            }
        }
    },
    methods: {
        ...mapMutations({
            setStateSearch: 'setStateSearch',
            setStateCatalog: 'setStateCatalog'
        }),
        closeSearch() {
            this.searchValue = '';
            this.setStateSearch(false);
        },
        searchCat(val) {
            let lowerValue = val.toLowerCase();
            let name, keyword;
            this.categoriesFound = this.searchCategories.filter(el => {
                name = el.name.toLowerCase();
                keyword = el.keyword.map(el => el.toLowerCase());
                return name.includes(lowerValue) || keyword.find(value => value.match(lowerValue));
            });
        },
        onEnter() {
            if (!this.searchValue.length) return;
            this.$router.push(this.localePath(`/cautare/${encodeURIComponent(this.search)}`));
            this.searchValue = '';
        },
        async onSearch(e) {
            if (e.key === 'Enter') {
                this.onEnter();
                this.closeSearch();
            } else if (typeof this.timeoutID == 'number') {
                clearTimeout(this.timeoutID);
            }

            this.timeoutID = setTimeout(async () => {
                this.searchCat(this.search);
                await this.searchProd(this.search);
            }, 1000);
        },
        async searchProd(val) {
            try {
                if (val) {
                    let data = await this.$axios.$get('general/v2/search/search/?query=' + val);
                    // console.log(results, 'results')
                    console.log(data, 'data');
                    this.categoriesFound = data.resultsByCategory;
                    this.productsFound = data.products;
                }
            } catch (e) {
                this.productsFound = [];
                console.error(e);
            }
        }
    }
};
